import request from '../utils/request'

//合同列表
export function contractList(contract_type,limit,page) {
    return request.post('/api/contract_list',{"contract_type":contract_type,"limit":limit,"page":page})
}
//合同列表搜索
export function contractSearch(contract_type,limit,page,doc_title,signer,begin_time,end_time) {
    return request.post('/api/contract_list',{"contract_type":contract_type,"limit":limit,"page":page,"doc_title":doc_title,"signer":signer,"begin_time":begin_time,"end_time":end_time})
}
//待我处理签署
export function uponMySignature(signer_list_id) {
    return request.post('/api/contract_one_sign_url',{"signer_list_id":signer_list_id})
}
//我发起的撤销
export function revocationContract(signer_list_id) {
    return request.post('/api/contract_sign_flow_revoke',{"signer_list_id":signer_list_id})
}
//下载合同
export function downloadContract(signer_list_id) {
    return request.post('/api/contract_download_one',{"signer_list_id":signer_list_id})
}
//批量签署
export function batchSigning(signer_list_ids) {
    return request.post('/api/contract_batch_sign_url',{"signer_list_ids":signer_list_ids})
}
//首页 合同份数
export function contractCopy() {
    return request.post('/api/index_info')
}
//证据材料
export function evidenceDetails(signer_list_id,is_main) {
    return request.post('/api/contract_evidence_detail',{"signer_list_id":signer_list_id,"is_main":is_main})
}
//保存证据
export function material(signer_list_id,evidence_data,is_main) {
    return request.post('/api/contract_save_evidence',{"signer_list_id":signer_list_id,"evidence_data":evidence_data,"is_main":is_main})
}
//合同转仲裁案件详情
export function arbitrationInformation(signer_list_id) {
    return request.post('/api/contract_to_zhcai_detail',{"signer_list_id":signer_list_id})
}
//保存转入仲裁信息
export function saveTransfer(signer_list_id,zhcai_type,doc_title,contract_sn,sign_time,qingqiu,liyou,signers) {
    let obj={
        "signer_list_id":signer_list_id,
        "zhcai_type":zhcai_type,
        "doc_title":doc_title,
        "contract_sn":contract_sn,
        "sign_time":sign_time,
        "qingqiu":qingqiu,
        "liyou":liyou,
        "signers":signers
    }
    return request.post('/api/contract_to_zhcai_save',obj)
}
//获取关联补充证据清单
export function associationList() {
    return request.post('/api/zhcai_case_extra_evilist')
}
//绑定补充证据清单接口
export function bindingList(case_ids,extra_id) {
    return request.post('/api/batch_bind_extra_evi',{"case_ids":case_ids,"extra_id":extra_id})
}
//查看合同详情
export function contractParticulars(signer_list_id) {
    return request.post('/api/contract_detail',{"signer_list_id":signer_list_id})
}
//查看合同文件
export function contractDocument(signer_list_id) {
    return request.post('/api/cont_file_url',{"signer_list_id":signer_list_id})
}
//关联证据清单
export function associatedList() {
    return request.post('/api/zhcai_case_evilist')
}
//绑定关联证据清单
export function bindEvidenceList(case_ids,product_id) {
    return request.post('/api/batch_bind_evi',{"case_ids":case_ids,"product_id":product_id})
}
//合同延期
export function extensionContract(data) {
    return request({
        url:'/api/contract_sign_delay',
        method:'post',
        data
    })
}
//发起失败合同详情
export function failureDetails(data) {
    return request({
        url:'/api/contract_detail_shibai',
        method:'post',
        data
    })
}
//催办
export function urgeContract(data) {
    return request({
        url:'/api/contract_cui_qian',
        method:'post',
        data
    })
}
//合同绑定证据清单
export function bindEvidence(data){
    return request({
        url:'/api/batch_hetong_bind_evi',
        method:'post',
        data
    })
}